<template>
  <div class="shifts-setting">
    <div class="wrap-content">
      <div class="fixed-display" v-if="checkPath">
        <div class="setting-title" data-test="title">勤務表・シフト</div>
        <div class="setting-tab-title-bar">
          <div v-for="titleObj in tabTitles" :key="titleObj.id">
            <base-setting-tab-title
              :title="titleObj.title"
              :link="titleObj.link"
              :names="titleObj.names"
            />
          </div>
        </div>
      </div>
      <div class="content-body">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import BaseSettingTabTitle from '@/components/parts/atoms/BaseSettingTabTitle.vue'
export default {
  name: 'ShiftsSetting',
  components: {
    BaseSettingTabTitle
  },
  data() {
    return {
      tabTitles: [
        {
          id: 1,
          title: '勤務表',
          link: 'staff-working-dates',
          names: ['staff-working-dates']
        },
        { id: 2, title: 'シフト', link: 'shifts', names: ['shifts'] },
        {
          id: 3,
          title: '週シフト',
          link: 'shift-patterns',
          names: ['shift-patterns']
        }
      ]
    }
  },
  computed: {
    checkPath() {
      if (
        this.$route.params.id ||
        this.$route.path === '/settings/shifts/shifts/new' ||
        this.$route.path === '/settings/shifts/shift-patterns/new'
      ) {
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.shifts-setting {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  text-align: left;
  > .wrap-content {
    > .fixed-display {
      position: sticky;
      position: -webkit-sticky;
      top: 24px;
      transform: translateY(-24px);
      padding-top: 24px;
      margin-bottom: -24px;
      z-index: 100;
      background-color: #{$white};
      > .setting-title {
        font-size: 20px;
        font-weight: bold;
      }
      > .setting-tab-title-bar {
        display: flex;
        flex-direction: row;
        height: 26px;
        margin-top: 20px;
        padding-bottom: -4px;
        border-bottom: 1px solid;
        border-color: #{$light-grey};
        box-sizing: border-box;
      }
    }
    > .content-body {
      min-width: 614px;
    }
  }
}
</style>
